/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * Publizon Library API
 * Pubhub exists in two separate environments, each with their own server, code and database. Please use the web service located at library-api.qa.pubhub.dk when developing and testing.
Orders/loans created in test environment will not be invoiced. Please request a new license key for the production environment when you're ready to go live.
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from "react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from "react-query";
import type {
  ApiResult,
  ChecklistResult,
  CreateLoanResult,
  FriendlyCardResult,
  GetV1UserLoansParams,
  LibraryProfile,
  LoanListResult,
  LoanResult,
  LoanStatusListResult,
  LoanStatusResult,
  PostV1UserLoansIdentifierParams,
  ProductListResult,
  ProductResult,
  ReservationInput,
  ReservationListResult
} from "./model";
import { fetcher } from "./mutator/fetcher";
import type { ErrorType, BodyType } from "./mutator/fetcher";

/**
 * Sample **request**:
            
    GET /friendly
    {
        "name": "Some name"
    }
 * @summary Gets the user's friendly card number.
 */
export const getV1UserCardnumberFriendly = (signal?: AbortSignal) => {
  return fetcher<FriendlyCardResult[]>({
    url: `/v1/user/cardnumber/friendly`,
    method: "GET",
    signal
  });
};

export const getGetV1UserCardnumberFriendlyQueryKey = () => {
  return [`/v1/user/cardnumber/friendly`] as const;
};

export const getGetV1UserCardnumberFriendlyQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
  TError = ErrorType<ApiResult>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1UserCardnumberFriendlyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>
  > = ({ signal }) => getV1UserCardnumberFriendly(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV1UserCardnumberFriendlyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>
>;
export type GetV1UserCardnumberFriendlyQueryError = ErrorType<ApiResult>;

/**
 * @summary Gets the user's friendly card number.
 */

export function useGetV1UserCardnumberFriendly<
  TData = Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
  TError = ErrorType<ApiResult>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserCardnumberFriendly>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetV1UserCardnumberFriendlyQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all checklist items of the user.
 */
export const getV1UserChecklist = (signal?: AbortSignal) => {
  return fetcher<ChecklistResult>({
    url: `/v1/user/checklist`,
    method: "GET",
    signal
  });
};

export const getGetV1UserChecklistQueryKey = () => {
  return [`/v1/user/checklist`] as const;
};

export const getGetV1UserChecklistQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserChecklist>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserChecklist>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1UserChecklistQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1UserChecklist>>
  > = ({ signal }) => getV1UserChecklist(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserChecklist>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV1UserChecklistQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserChecklist>>
>;
export type GetV1UserChecklistQueryError = ErrorType<unknown>;

/**
 * @summary List all checklist items of the user.
 */

export function useGetV1UserChecklist<
  TData = Awaited<ReturnType<typeof getV1UserChecklist>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserChecklist>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetV1UserChecklistQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a book to the user's checklist.
 */
export const postV1UserChecklistIdentifier = (identifier: string) => {
  return fetcher<ApiResult>({
    url: `/v1/user/checklist/${identifier}`,
    method: "POST"
  });
};

export const getPostV1UserChecklistIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
    TError,
    { identifier: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
    { identifier: string }
  > = (props) => {
    const { identifier } = props ?? {};

    return postV1UserChecklistIdentifier(identifier);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1UserChecklistIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>
>;

export type PostV1UserChecklistIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Add a book to the user's checklist.
 */
export const usePostV1UserChecklistIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
    TError,
    { identifier: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof postV1UserChecklistIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  const mutationOptions =
    getPostV1UserChecklistIdentifierMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete a book from the user's checklist.
 */
export const deleteV1UserChecklistIdentifier = (identifier: string) => {
  return fetcher<ApiResult>({
    url: `/v1/user/checklist/${identifier}`,
    method: "DELETE"
  });
};

export const getDeleteV1UserChecklistIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
    TError,
    { identifier: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
    { identifier: string }
  > = (props) => {
    const { identifier } = props ?? {};

    return deleteV1UserChecklistIdentifier(identifier);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV1UserChecklistIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>
>;

export type DeleteV1UserChecklistIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Delete a book from the user's checklist.
 */
export const useDeleteV1UserChecklistIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
    TError,
    { identifier: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteV1UserChecklistIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  const mutationOptions =
    getDeleteV1UserChecklistIdentifierMutationOptions(options);

  return useMutation(mutationOptions);
};

export const getV1LibraryProfile = (signal?: AbortSignal) => {
  return fetcher<LibraryProfile>({
    url: `/v1/library/profile`,
    method: "GET",
    signal
  });
};

export const getGetV1LibraryProfileQueryKey = () => {
  return [`/v1/library/profile`] as const;
};

export const getGetV1LibraryProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1LibraryProfile>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1LibraryProfile>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1LibraryProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1LibraryProfile>>
  > = ({ signal }) => getV1LibraryProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1LibraryProfile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV1LibraryProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1LibraryProfile>>
>;
export type GetV1LibraryProfileQueryError = ErrorType<unknown>;

export function useGetV1LibraryProfile<
  TData = Awaited<ReturnType<typeof getV1LibraryProfile>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1LibraryProfile>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetV1LibraryProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists all active loans of the user.
 */
export const getV1UserLoans = (
  params?: GetV1UserLoansParams,
  signal?: AbortSignal
) => {
  return fetcher<LoanListResult>({
    url: `/v1/user/loans`,
    method: "GET",
    params,
    signal
  });
};

export const getGetV1UserLoansQueryKey = (params?: GetV1UserLoansParams) => {
  return [`/v1/user/loans`, ...(params ? [params] : [])] as const;
};

export const getGetV1UserLoansQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserLoans>>,
  TError = ErrorType<unknown>
>(
  params?: GetV1UserLoansParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getV1UserLoans>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1UserLoansQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1UserLoans>>> = ({
    signal
  }) => getV1UserLoans(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserLoans>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV1UserLoansQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserLoans>>
>;
export type GetV1UserLoansQueryError = ErrorType<unknown>;

/**
 * @summary Lists all active loans of the user.
 */

export function useGetV1UserLoans<
  TData = Awaited<ReturnType<typeof getV1UserLoans>>,
  TError = ErrorType<unknown>
>(
  params?: GetV1UserLoansParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getV1UserLoans>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetV1UserLoansQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets details of a specific loan.
 */
export const getV1UserLoansIdentifier = (
  identifier: string,
  signal?: AbortSignal
) => {
  return fetcher<LoanResult>({
    url: `/v1/user/loans/${identifier}`,
    method: "GET",
    signal
  });
};

export const getGetV1UserLoansIdentifierQueryKey = (identifier: string) => {
  return [`/v1/user/loans/${identifier}`] as const;
};

export const getGetV1UserLoansIdentifierQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1UserLoansIdentifierQueryKey(identifier);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1UserLoansIdentifier>>
  > = ({ signal }) => getV1UserLoansIdentifier(identifier, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!identifier,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV1UserLoansIdentifierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserLoansIdentifier>>
>;
export type GetV1UserLoansIdentifierQueryError = ErrorType<unknown>;

/**
 * @summary Gets details of a specific loan.
 */

export function useGetV1UserLoansIdentifier<
  TData = Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getV1UserLoansIdentifier>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetV1UserLoansIdentifierQueryOptions(
    identifier,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a new loan.
 */
export const postV1UserLoansIdentifier = (
  identifier: string,
  params?: PostV1UserLoansIdentifierParams
) => {
  return fetcher<CreateLoanResult>({
    url: `/v1/user/loans/${identifier}`,
    method: "POST",
    params
  });
};

export const getPostV1UserLoansIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
    TError,
    { identifier: string; params?: PostV1UserLoansIdentifierParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
  TError,
  { identifier: string; params?: PostV1UserLoansIdentifierParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
    { identifier: string; params?: PostV1UserLoansIdentifierParams }
  > = (props) => {
    const { identifier, params } = props ?? {};

    return postV1UserLoansIdentifier(identifier, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1UserLoansIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1UserLoansIdentifier>>
>;

export type PostV1UserLoansIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Creates a new loan.
 */
export const usePostV1UserLoansIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
    TError,
    { identifier: string; params?: PostV1UserLoansIdentifierParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof postV1UserLoansIdentifier>>,
  TError,
  { identifier: string; params?: PostV1UserLoansIdentifierParams },
  TContext
> => {
  const mutationOptions = getPostV1UserLoansIdentifierMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get loan status of a specific product.
 */
export const getV1LoanstatusIdentifier = (
  identifier: string,
  signal?: AbortSignal
) => {
  return fetcher<LoanStatusResult>({
    url: `/v1/loanstatus/${identifier}`,
    method: "GET",
    signal
  });
};

export const getGetV1LoanstatusIdentifierQueryKey = (identifier: string) => {
  return [`/v1/loanstatus/${identifier}`] as const;
};

export const getGetV1LoanstatusIdentifierQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ?? getGetV1LoanstatusIdentifierQueryKey(identifier);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>
  > = ({ signal }) => getV1LoanstatusIdentifier(identifier, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!identifier,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV1LoanstatusIdentifierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>
>;
export type GetV1LoanstatusIdentifierQueryError = ErrorType<unknown>;

/**
 * @summary Get loan status of a specific product.
 */

export function useGetV1LoanstatusIdentifier<
  TData = Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1LoanstatusIdentifier>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const options = getGetV1LoanstatusIdentifierQueryOptions(
    identifier,
    queryOptions
  );

  const query = useQuery(options) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
}

/**
 * @summary Get loan status of all products.
 */
export const postV1Loanstatus = (postV1LoanstatusBody: BodyType<string[]>) => {
  return fetcher<LoanStatusListResult>({
    url: `/v1/loanstatus`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: postV1LoanstatusBody
  });
};

export const getPostV1LoanstatusMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1Loanstatus>>,
    TError,
    { data: BodyType<string[]> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1Loanstatus>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1Loanstatus>>,
    { data: BodyType<string[]> }
  > = (props) => {
    const { data } = props ?? {};

    return postV1Loanstatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1LoanstatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1Loanstatus>>
>;
export type PostV1LoanstatusMutationBody = BodyType<string[]>;
export type PostV1LoanstatusMutationError = ErrorType<unknown>;

/**
 * @summary Get loan status of all products.
 */
export const usePostV1Loanstatus = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1Loanstatus>>,
    TError,
    { data: BodyType<string[]> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof postV1Loanstatus>>,
  TError,
  { data: BodyType<string[]> },
  TContext
> => {
  const mutationOptions = getPostV1LoanstatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get a specific product.
 */
export const getV1ProductsIdentifier = (
  identifier: string,
  signal?: AbortSignal
) => {
  return fetcher<ProductResult>({
    url: `/v1/products/${identifier}`,
    method: "GET",
    signal
  });
};

export const getGetV1ProductsIdentifierQueryKey = (identifier: string) => {
  return [`/v1/products/${identifier}`] as const;
};

export const getGetV1ProductsIdentifierQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetV1ProductsIdentifierQueryKey(identifier);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1ProductsIdentifier>>
  > = ({ signal }) => getV1ProductsIdentifier(identifier, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!identifier,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV1ProductsIdentifierQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1ProductsIdentifier>>
>;
export type GetV1ProductsIdentifierQueryError = ErrorType<unknown>;

/**
 * @summary Get a specific product.
 */

export function useGetV1ProductsIdentifier<
  TData = Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
  TError = ErrorType<unknown>
>(
  identifier: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getV1ProductsIdentifier>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetV1ProductsIdentifierQueryOptions(
    identifier,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all products.
 */
export const getV1Products = (signal?: AbortSignal) => {
  return fetcher<ProductListResult>({
    url: `/v1/products`,
    method: "GET",
    signal
  });
};

export const getGetV1ProductsQueryKey = () => {
  return [`/v1/products`] as const;
};

export const getGetV1ProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1Products>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1Products>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1ProductsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1Products>>> = ({
    signal
  }) => getV1Products(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1Products>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV1ProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1Products>>
>;
export type GetV1ProductsQueryError = ErrorType<unknown>;

/**
 * @summary List all products.
 */

export function useGetV1Products<
  TData = Awaited<ReturnType<typeof getV1Products>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1Products>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetV1ProductsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lists all reservations of the user.
 */
export const getV1UserReservations = (signal?: AbortSignal) => {
  return fetcher<ReservationListResult>({
    url: `/v1/user/reservations`,
    method: "GET",
    signal
  });
};

export const getGetV1UserReservationsQueryKey = () => {
  return [`/v1/user/reservations`] as const;
};

export const getGetV1UserReservationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1UserReservations>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserReservations>>,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetV1UserReservationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1UserReservations>>
  > = ({ signal }) => getV1UserReservations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserReservations>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetV1UserReservationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1UserReservations>>
>;
export type GetV1UserReservationsQueryError = ErrorType<unknown>;

/**
 * @summary Lists all reservations of the user.
 */

export function useGetV1UserReservations<
  TData = Awaited<ReturnType<typeof getV1UserReservations>>,
  TError = ErrorType<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getV1UserReservations>>,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetV1UserReservationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Creates a new reservation.
 */
export const postV1UserReservationsIdentifier = (
  identifier: string,
  reservationInput: BodyType<ReservationInput>
) => {
  return fetcher<ApiResult>({
    url: `/v1/user/reservations/${identifier}`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: reservationInput
  });
};

export const getPostV1UserReservationsIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
    TError,
    { identifier: string; data: BodyType<ReservationInput> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
  TError,
  { identifier: string; data: BodyType<ReservationInput> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
    { identifier: string; data: BodyType<ReservationInput> }
  > = (props) => {
    const { identifier, data } = props ?? {};

    return postV1UserReservationsIdentifier(identifier, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1UserReservationsIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>
>;
export type PostV1UserReservationsIdentifierMutationBody =
  BodyType<ReservationInput>;
export type PostV1UserReservationsIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Creates a new reservation.
 */
export const usePostV1UserReservationsIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
    TError,
    { identifier: string; data: BodyType<ReservationInput> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof postV1UserReservationsIdentifier>>,
  TError,
  { identifier: string; data: BodyType<ReservationInput> },
  TContext
> => {
  const mutationOptions =
    getPostV1UserReservationsIdentifierMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Updates the phone number and email address of a specific reservation.
 */
export const patchV1UserReservationsIdentifier = (
  identifier: string,
  reservationInput: BodyType<ReservationInput>
) => {
  return fetcher<ApiResult>({
    url: `/v1/user/reservations/${identifier}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: reservationInput
  });
};

export const getPatchV1UserReservationsIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
    TError,
    { identifier: string; data: BodyType<ReservationInput> },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
  TError,
  { identifier: string; data: BodyType<ReservationInput> },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
    { identifier: string; data: BodyType<ReservationInput> }
  > = (props) => {
    const { identifier, data } = props ?? {};

    return patchV1UserReservationsIdentifier(identifier, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV1UserReservationsIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>
>;
export type PatchV1UserReservationsIdentifierMutationBody =
  BodyType<ReservationInput>;
export type PatchV1UserReservationsIdentifierMutationError = ErrorType<unknown>;

/**
 * @summary Updates the phone number and email address of a specific reservation.
 */
export const usePatchV1UserReservationsIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
    TError,
    { identifier: string; data: BodyType<ReservationInput> },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchV1UserReservationsIdentifier>>,
  TError,
  { identifier: string; data: BodyType<ReservationInput> },
  TContext
> => {
  const mutationOptions =
    getPatchV1UserReservationsIdentifierMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Cancels a reservation.
 */
export const deleteV1UserReservationsIdentifier = (identifier: string) => {
  return fetcher<ApiResult>({
    url: `/v1/user/reservations/${identifier}`,
    method: "DELETE"
  });
};

export const getDeleteV1UserReservationsIdentifierMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
    TError,
    { identifier: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
    { identifier: string }
  > = (props) => {
    const { identifier } = props ?? {};

    return deleteV1UserReservationsIdentifier(identifier);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteV1UserReservationsIdentifierMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>
>;

export type DeleteV1UserReservationsIdentifierMutationError =
  ErrorType<unknown>;

/**
 * @summary Cancels a reservation.
 */
export const useDeleteV1UserReservationsIdentifier = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
    TError,
    { identifier: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteV1UserReservationsIdentifier>>,
  TError,
  { identifier: string },
  TContext
> => {
  const mutationOptions =
    getDeleteV1UserReservationsIdentifierMutationOptions(options);

  return useMutation(mutationOptions);
};
